import React, { useEffect, useRef, useState } from 'react'
import Logo from '../../images/Logo.svg'
import { useDispatch, useSelector } from 'react-redux'
import { BsChevronDown, BsGlobe2 } from 'react-icons/bs'
import Langs from '../../utilities/Langs'
import { changeLang } from '../../redux/slices/langSlice'
import { Link } from 'react-router-dom'

const NotTopMenu = () => {
    const [isLangOpen, setIsLangOpen] = useState(false)
    const langRef = useRef(null)
    const dispatch = useDispatch()
    const { lang } = useSelector((state) => state.lang)

    const handleLanguageChange = (language) => {
        dispatch(changeLang(language))
        setIsLangOpen(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (langRef.current && !langRef.current.contains(event.target)) {
                setIsLangOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <div className='d-flex justify-content-between align-items-center'>
            <div><Link to="/"><img src={Logo} alt="" /></Link></div>
            <div className='select-lang position-relative cp' ref={langRef}>
                <div onClick={() => setIsLangOpen(!isLangOpen)} className='d-flex justify-content-center align-items-center'>
                    <div className='mr-1 mb-1 color3'><BsGlobe2 size={14} /></div>
                    <span className='f12 color3'>{lang.toUpperCase()}</span>
                    <div className='ml-1 mb-1 color3'><BsChevronDown size={14} /></div>
                </div>
                {isLangOpen && (
                    <div className='lang-dropdown shadow'>
                        {Langs.map((language) => (
                            <div
                                key={language}
                                className='lang-item'
                                onClick={() => handleLanguageChange(language)}
                            >
                                <span className='f14'>{language.toUpperCase()}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default NotTopMenu
